import { companyRoutes } from './companies';
import { orderRoutes } from './orders';
import { opportunitySettingsRoutes } from './opportunities';

export const accountRoutes = [
  {
    path: 'accounts',
    children: [...companyRoutes, ...orderRoutes, ...opportunitySettingsRoutes],
  },
];
